import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  dir: "rtl",
  class: "pointer-events-none fixed inset-x-4 top-4 z-[2000] flex justify-center sm:inset-x-auto sm:right-6 sm:top-6 sm:w-[min(26rem,calc(100vw-3rem))]"
}
const _hoisted_2 = ["role", "aria-live"]
const _hoisted_3 = { class: "flex items-start gap-3 p-4" }
const _hoisted_4 = { class: "min-w-0 flex-1 pt-0.5 text-right" }
const _hoisted_5 = { class: "text-sm font-bold text-slate-900" }
const _hoisted_6 = { class: "mt-1 break-words text-sm leading-6 text-slate-600" }
const _hoisted_7 = { class: "h-1 w-full bg-slate-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (_ctx.toast.status)
          ? (_openBlock(), _createElementBlock("section", {
              key: _ctx.toast.id,
              class: _normalizeClass(["toast-card pointer-events-auto w-full overflow-hidden rounded-2xl border bg-white shadow-2xl shadow-slate-900/10", _ctx.tone.border]),
              style: _normalizeStyle({ '--toast-duration': `${_ctx.duration}ms` }),
              role: _ctx.isError ? 'alert' : 'status',
              "aria-live": _ctx.isError ? 'assertive' : 'polite'
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: _normalizeClass(["flex h-10 w-10 shrink-0 items-center justify-center rounded-xl", _ctx.tone.icon])
                }, [
                  _createVNode(_component_v_icon, { size: "21" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tone.symbol), 1)
                    ]),
                    _: 1
                  })
                ], 2),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.tone.title), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.toast.message), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-cyan-600",
                  "aria-label": "بستن پیام",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["toast-progress h-full rounded-full", _ctx.tone.progress])
                }, null, 2)
              ])
            ], 14, _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}